import { Label } from '@design-system/label';
import {
  Upload,
  UploadArea,
  UploadButton,
  UploadError,
  UploadInputDisplay,
  UploadTrigger,
} from '@design-system/upload';
import { Textfield } from '@shared/fields/text-field';
import { MAX_INTERVIEWER_IMAGE_SIZE } from '@shared/forms/interviewer';
import type { TEwallet } from '@shared/types/ewallet';
import { useFormikContext } from 'formik';

const EWalletEdit = () => {
  const { values, setFieldValue } = useFormikContext<TEwallet>();

  const handleFileUpload = (file: File | null) => {
    const formData = new FormData();
    if (file) {
      const modifiedAvatar = new File([file], file.name.substring(0, 99), {
        type: file.type,
      });
      formData.append('logo', modifiedAvatar);
      setFieldValue('logo', file);
    }
  };

  return (
    <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
      <p className='text-gray-600 font-medium text-sm mb-2'>E-Wallet</p>

      <div className='flex items-center gap-2'>
        <div className='w-full'>
          <Textfield
            name='provider_name'
            type='text'
            placeholder='ex: Wallet Name'
            className='w-full'
            label='Wallet'
          />
        </div>
        <div className='w-full'>
          <Upload
            maxSize={MAX_INTERVIEWER_IMAGE_SIZE}
            onFileChange={handleFileUpload}
          >
            <UploadArea>
              <Label>Logo</Label>
              <UploadTrigger className='flex-1 flex h-[50px] w-full'>
                <UploadButton />
                <UploadInputDisplay
                  placeholder={
                    typeof values.logo === 'string'
                      ? values.logo.split('/').pop()
                      : ''
                  }
                />
              </UploadTrigger>
            </UploadArea>
            <UploadError />
          </Upload>
        </div>
      </div>
      <Textfield
        name='recipient_name'
        type='text'
        placeholder='ex: Ahmed'
        label='Recipient Name'
      />
      <Textfield
        name='recipient_number'
        type='text'
        placeholder='ex: +20124356762'
        label="Recipient's number/ ID"
      />
    </div>
  );
};

export default EWalletEdit;
